import React, { useState } from "react";
import Navbar from "../components/site/Navbar";
import Ticker from "../components/site/Ticker";
import Hero from "../components/site/Hero";
import Story from "../components/site/Story";
import TheLeak from "../components/site/TheLeak";
import HowItWorks from "../components/site/HowItWorks";
import Features from "../components/site/Features";
import Industries from "../components/site/Industries";
import Pricing from "../components/site/Pricing";
import Urgency from "../components/site/Urgency";
import FAQ from "../components/site/FAQ";
import FinalCTA from "../components/site/FinalCTA";
import Footer from "../components/site/Footer";
import LeadModal from "../components/site/LeadModal";
import Reveal from "../components/site/Reveal";

export default function LandingPage() {
  const [leadOpen, setLeadOpen] = useState(false);

  const openLead = () => setLeadOpen(true);
  const closeLead = () => setLeadOpen(false);

  const scrollToDemo = () => {
    const el = document.getElementById("live-demo");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main className="bg-[#0A0F1E] text-white" data-testid="landing-page">
      <Navbar onBookDemo={openLead} />
      <Ticker />
      {/* Hero already has its own initial-load fs-reveal animation */}
      <Hero onBookDemo={openLead} onTryAgent={scrollToDemo} />
      <Reveal><Story /></Reveal>
      <Reveal><TheLeak /></Reveal>
      <Reveal><HowItWorks /></Reveal>
      <Reveal><Features /></Reveal>
      <Reveal><Industries /></Reveal>
      <Reveal><Pricing onBookDemo={openLead} /></Reveal>
      <Reveal><Urgency /></Reveal>
      <Reveal><FAQ /></Reveal>
      <Reveal><FinalCTA onBookDemo={openLead} onTryAgent={scrollToDemo} /></Reveal>
      <Footer />
      <LeadModal open={leadOpen} onClose={closeLead} />
    </main>
  );
}
